import type { FaireProductEntity } from "../../entity_types/product";

export const p_45vxkurctp: FaireProductEntity = {
  token: "p_45vxkurctp",
  type: "product",
  name: "Crunchy Cassava Crackers GF Nutrient Dense Snacks 6 uni/case",
  brandToken: "b_apg589hg34",
  brandName: "Cult Crackers",
  imageUrl: "https://cdn.faire.com/fastly/fef7b56512ca86a9864f14734aa95fbbc8f4cc6dc64f27d261a7f419530ee17e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc9f8eff04e2cebb080ad1dbb6067776aadafb6e810d7337dfee9c30255a022b.jpeg",
    "https://cdn.faire.com/fastly/3e04f5cea5a22fafe80f5a2df62f17445e8f11828fe5b8f45364b0483be741d0.jpeg",
    "https://cdn.faire.com/fastly/b0ef2aa1507fe5e588076e76408b114aaa76ff7d7926a8059b1ed4e04be69423.jpeg",
    "https://cdn.faire.com/fastly/47bf7086f5067efe989a3f8ebd0dc52e515d202ca9854247aa567ed11e0bc011.jpeg",
    "https://cdn.faire.com/fastly/f4ce2ceb946e7869204cbebfebb0d83bf1bb28c3fbc95be903f045d317daa2d2.jpeg",
    "https://cdn.faire.com/fastly/93b2980c5f340de21ef40ea50a3ec612329b0e7bda374af127bd14341d8bec55.jpeg"
  ],
  priceDollars: 4,
  description: "Our best-selling grain-free, gluten-free Crunchy Cassava Crackers are good for you. As a better-for-you food brand, we hand bake our insanely good plant-based crackers in small batches. They're packed with flavor and crunch from six powerhouse seeds. Eat them straight out of the bag or with your favorite fixings. Natural fit for gourmet & specialty grocery, markets, hotels, cheese shops, butcher shops, juice bars, cafe, restaurants, fitness studio, yoga studio, mercantile, grocery store, cheeseboard, charcuterie boards, wine bar, winery, wineries and delis. Perfect on cheese boards, charcuterie boards, kid-friendly snacks, healthy snacks, gluten-free, grain-free, handmade, allergen-friendly, appetizers, whole 30, nutrient dense, high protein, high fiber.\n\nCalifornia warning: Can expose you to lead, a carcinogen and reproductive toxicant. See www.P65Warnings.ca.gov/food.",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:46:36.829Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
